module.exports = __webpack_public_path__ + "img/defaultIcon_patients.9a09b44b.png";